import React from "react";
import VDBIcon from "@components/icons/VDBIcon";
import { Image } from "react-native";
import { useTheme } from "styled-components/native";
import {
  DEFAULT_CERT_ICON_NAME,
  useCertificateIconResolver,
} from "@utils/certificateIcons";

type CertificateIconProps = {
  mediaType?: string;
  labId?: string;
  size?: number;
  color?: string;
  fallbackIcon?: string;
};

const CertificateIcon = ({
  mediaType,
  labId,
  size = 34,
  color,
  fallbackIcon,
}: CertificateIconProps) => {
  const resolveCertificateIcon = useCertificateIconResolver();
  const theme = useTheme();
  const iconProps = resolveCertificateIcon(
    mediaType,
    labId,
    fallbackIcon,
    color
  );

  const themeColor = iconProps.color
    ? iconProps.color.startsWith("#")
      ? iconProps.color
      : (theme as any)[iconProps.color]
    : undefined;

  const resolvedColor = themeColor ? themeColor : null;
  const isFallbackIcon = iconProps.name === DEFAULT_CERT_ICON_NAME;

  if (iconProps.source) {
    const imageSource =
      typeof iconProps?.source === "string"
        ? { uri: iconProps?.source }
        : iconProps?.source;
    return (
      <Image
        source={imageSource}
        style={{
          width: iconProps?.size ? iconProps?.size : 62,
          height: iconProps?.size ? iconProps?.size : 62,
          ...(resolvedColor ? { tintColor: resolvedColor } : {}),
        }}
        resizeMode="contain"
      />
    );
  }

  return (
    <VDBIcon
      name={iconProps.name}
      uri={iconProps.uri}
      variant={iconProps.variant}
      size={isFallbackIcon ? 34 : size}
      color={resolvedColor}
    />
  );
};

export default CertificateIcon;
